var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-btn',{attrs:{"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.onOpenFaq.apply(null, arguments)}}},[_c('v-icon',{attrs:{"color":"grey lighten-1"}},[_vm._v("mdi-information-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }